export default "__VITE_ASSET__$hDW67rb__"